<template>
  <card class="text-left">
    <template slot="header">
      <h4 class="card-title">랭킹 투표 설정</h4>
      <p class="card-category">대표 이미지를 설정합니다.</p>
    </template>

    <div class="row">
      <label class="col-sm-2 col-form-label">대표 이미지</label>
      <div class="col-sm-10 d-flex align-items-center" style="gap: 12px">
        <img v-if="imageUrl" :src="imageUrl" alt="대표 이미지" style="max-width: 160px; max-height: 90px; border-radius: 6px" />
        <div v-else class="text-muted small py-4 px-5" style="border: 1px dashed #ccc; border-radius: 6px">이미지 없음</div>
        <div>
          <label class="btn btn-sm btn-outline-primary mb-1" :class="{ disabled: !editable }">
            이미지 선택
            <input type="file" accept="image/*" style="display: none" :disabled="!editable" @change="onFileChange" />
          </label>
          <base-button v-if="imageUrl" @click="$emit('remove')" type="default" size="sm" :disabled="!editable">이미지 제거</base-button>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
import { Card, BaseButton } from "@/components/index";

export default {
  components: {
    Card,
    BaseButton,
  },
  props: {
    imageUrl: {
      type: String,
      default: null,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onFileChange(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = ""; // 같은 파일 재선택 허용
      if (!file) return;
      this.$emit("upload", file);
    },
  },
};
</script>
